if (!customElements.get("card-product")) {
  customElements.define(
    "card-product",
    class CardProduct extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        if (!this.form) return;

        this.sizeButtons = this.querySelectorAll(".size-option");

        // Add hidden add to cart button
        this.addToCartButton = document.createElement("button");
        this.addToCartButton.type = "submit";
        this.addToCartButton.name = "add";
        this.addToCartButton.className = "hidden-add-to-cart";
        this.addToCartButton.style.display = "none";
        this.form.appendChild(this.addToCartButton);

        this.setupSizeButtons();
        this.setupFormSubmit();
      }

      setupSizeButtons() {
        this.sizeButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const variantId = button.getAttribute("data-variant-id");
            const hiddenInput = this.form.querySelector('input[name="id"]');
            if (!hiddenInput) return;

            hiddenInput.value = variantId;

            // Trigger the hidden add to cart button after a short delay
            setTimeout(() => {
              this.addToCartButton.click();
            }, 100);
          });
        });
      }

      setupFormSubmit() {
        this.form.addEventListener("submit", (e) => {
          e.preventDefault();

          const formData = new FormData(this.form);

          // Get the cart drawer
          const cart = document.querySelector("cart-drawer");
          if (cart) {
            // Add sections to update
            formData.append(
              "sections",
              cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            // Set active element for focus management
            cart.setActiveElement(document.activeElement);
          }

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                // Handle error case
                console.error("Error adding to cart:", response.description);
                return;
              }

              // Try to find the cart drawer
              const cart = document.querySelector("cart-drawer");
              if (cart) {
                // Remove is-empty class if present
                cart.classList.remove("is-empty");
                // Render the updated cart contents
                cart.renderContents(response);
              } else {
                // If no cart drawer, refresh the page to show updated cart
                window.location.reload();
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        });
      }
    }
  );
}
